/* import __COLOCATED_TEMPLATE__ from './crossing-card.hbs'; */
import Component from '@glimmer/component';

/**
 * CrossingCard Component
 *
 * Displays a single timing point crossing card with:
 * - Place (ordinal), bib, name
 * - Elapsed time from start
 * - Time back from leader
 * - Watchlist indicator
 *
 * @param {Object} crossing - Crossing data object with:
 *   - uuid: Record UUID
 *   - entryUuid: Entry UUID
 *   - bib: Bib number
 *   - name: Athlete name
 *   - place: Current place (number)
 *   - elapsed: Elapsed time in ms
 *   - elapsedFormatted: Formatted elapsed time
 *   - timeBack: Time behind leader in ms (0 for leader)
 *   - timeBackFormatted: Formatted time back
 *   - isWatched: Boolean if on watchlist
 *   - isFading: Boolean if card is fading out
 */
export default class CrossingCardComponent extends Component {
}
